import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { SeoRoutePipe } from '@app/pipes/seo-route.pipe';

import { VERTICALS } from '@handyhand/i18n';
import { SeoSegmentsToken } from '@app/core/env.tokens';
import { LocalizationService } from '@services/logic/localization.service';

@Component({
  selector: 'app-vertical-link-box-component',
  templateUrl: './vertical-link-box.component.html',
  styleUrls: ['./vertical-link-box.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, SeoRoutePipe],
})
export class VerticalLinkBoxComponent {
  private readonly localizationService = inject(LocalizationService);
  private readonly seg = inject(SeoSegmentsToken);

  private readonly languageCode = this.localizationService.languageCode;
  private readonly countryCode = this.localizationService.routingCountryCode;

  protected readonly verticals = computed(() => {
    const languageCode = this.languageCode();
    const countryCode = this.countryCode;
    const serviceSuffix = this.seg.suffix.serviceVertical;

    return VERTICALS.map((vertical) => ({
      label: vertical.label[languageCode],
      link: `${vertical.path[countryCode]}/${serviceSuffix}`,
    }));
  });
}
